/* src/app/order/order-pause-dialog/order-pause-dialog.component.scss */
.content {
  padding: 20px 30px;
}
.textarea {
  background-color: aliceblue;
  border-radius: 5px;
  padding: 10px 5px important;
}
.title {
  font-weight: 600;
  text-align: center;
  font-size: 18px;
}
.body {
  white-space: pre-line;
  font-size: 14px;
  font-weight: 400;
}
.error-container .error-message {
  display: flex;
  align-items: center;
  color: var(--ion-color-danger);
  font-size: 14px;
}
/*# sourceMappingURL=order-pause-dialog.component-E74I5INA.css.map */
